import { useEffect, useRef } from "react"
import { useLocation } from "@reach/router"

export default function ScrollObserver() {
  const { pathname } = useLocation()
  const observerRef = useRef(null)
  const mutationObserverRef = useRef(null)

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add("active")
      }),
      { threshold: 0.1 }
    )

    const observeScrollElements = () => {
      document.querySelectorAll("[data-scroll]:not(.observed)").forEach(el => {
        el.classList.add("observed")
        observerRef.current.observe(el)
        const rect = el.getBoundingClientRect()
        if (rect.top < window.innerHeight && rect.bottom > 0) el.classList.add("active")
      })
    }

    mutationObserverRef.current = new MutationObserver(observeScrollElements)
    mutationObserverRef.current.observe(document.body, { childList: true, subtree: true })

    observeScrollElements()

    return () => {
      observerRef.current?.disconnect()
      mutationObserverRef.current?.disconnect()
    }
  }, [pathname])

  return null
}
